import { useEffect, useRef } from 'react';
import clsx from 'clsx';

import { lockScroll, unlockScroll } from '@utils/lockScroll';

import { useVh } from '@hooks/useVh';

import NavMenu from '../NavMenu/NavMenu';
import LangSwitch from '../LangSwitch/LangSwitch';
import Actions from '../Actions/Actions';

import css from './MobMenu.module.scss';

const MobMenu = ({
  isMobile,
  isMobileMenuOpen,
  setMobileMenuOpen,
  navigationData,
  buttonsData,
}) => {
  const menuRef = useRef(null);

  useEffect(() => {
    if (isMobileMenuOpen) {
      lockScroll(menuRef.current);
      return () => unlockScroll();
    }

    unlockScroll();
  }, [isMobileMenuOpen]);

  useVh();

  return (
    <div
      ref={menuRef}
      className={clsx(css.mobmenu, isMobileMenuOpen && css.isOpen)}
    >
      <div className={css.mobmenu__body}>
        <div className={clsx(css.mobmenu__container, 'container')}>
          <div className={css.mobmenu__content}>
            <div className={css.mobmenu__box}>
              <NavMenu
                isMobile={isMobile}
                setMobileMenuOpen={setMobileMenuOpen}
                navigationData={navigationData}
              />
              <LangSwitch isMobile={isMobile} />
            </div>

            <Actions isMobile={isMobile} buttonsData={buttonsData} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobMenu;
